import { UpdateUserEntityRequest } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const updateUserEntity = (
  req: Partial<UpdateUserEntityRequest>
): Promise<void> =>
  request({
    url: '/service/userv2service/UpdateUserEntity',
    body: req,
  }).then((r) => r.body);
